import React, { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

interface ProtectedRouteProps {
  children: React.ReactNode
  requireAuth?: boolean
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireAuth = true 
}) => {
  const { isAuthenticated, loading, refreshAuth } = useAuth()
  const location = useLocation()

  // 在组件挂载时检查URL中是否有code参数，如果有则刷新认证状态
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')
    if (code) {
      console.log('🔍 检测到URL中的code参数，刷新认证状态')
      refreshAuth()
    }
  }, [refreshAuth])

  // 如果正在加载，显示加载状态
  if (loading) {
    return (
      <div className="mobile-loading">
        <div className="loading-text">验证登录状态中...</div>
      </div>
    )
  }

  // 如果需要认证但用户未登录，跳转到登录页（保留 OAuth 的 code/state，避免丢码后反复全量登录写库）
  if (requireAuth && !isAuthenticated) {
    const from = location.pathname !== '/login' ? location.pathname : '/dashboard'
    const params = new URLSearchParams(location.search)
    params.set('from', from)
    return <Navigate to={`/login?${params.toString()}`} replace />
  }

  // 如果不需要认证但用户已登录，跳转到仪表盘
  if (!requireAuth && isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }

  // 正常渲染子组件
  return <>{children}</>
}

export default ProtectedRoute
